import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { ContactGroupService } from '@services/contact-group.service';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';

@Component({
  selector: 'app-contact-groups-index',
  templateUrl: './contact-groups-index.component.html',
  styleUrls: ['./contact-groups-index.component.scss']
})
export class ContactGroupsIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public data: any;
  public displayedColumns = ['name', 'visible_to', 'type', 'user_count', 'created_by_user', 'created_at', 'actions'];
  public dataLoaded = false;
  public node: Breadcrumb;
  constructor(
    public contactGroupService: ContactGroupService,
    public router: Router,
    public state: State,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: contactGroupService,
      router,
      state,
      snackbarService,
      dialog
    });
    this.setPageVars({
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.node = {
      label: 'Contact Groups',
      link: 'contact-groups',
    };
    this.buildSettingsBreadcrumb(this.node);
  }

}
